module.exports = __webpack_public_path__ + "img/laboratorio5_4-3.889188c5.webp";